export type CallTypeBadge = {
  label: string;
  bg: string;
  color: string;
  border: string;
};

export const canSeeSupervisorBadges = (access?: string | null) =>
  String(access || '').toLowerCase() === 'team_lead';

export function buildCallTypeBadges(
  record: any,
  opts: { access?: string | null; includeProfileType?: boolean } = {},
): CallTypeBadge[] {
  const supervisor = canSeeSupervisorBadges(opts.access);
  const profileType = opts.includeProfileType
    ? String(record?.agent_profile_type || '').trim().toUpperCase()
    : '';

  return [
    profileType && { label: profileType, bg: '#f1f5f9', color: '#334155', border: '#cbd5e1' },
    record?.call_group_id && { label: 'Call Group', bg: '#eff6ff', color: '#1e40af', border: '#bfdbfe' },
    record?.campaign_id && { label: 'Campaign', bg: '#fdf4ff', color: '#86198f', border: '#f5d0fe' },
    record?.is_transfer && { label: 'Transfer', bg: '#eef2ff', color: '#3730a3', border: '#c7d2fe' },
    record?.is_conference && { label: 'Conference', bg: '#ecfeff', color: '#155e75', border: '#a5f3fc' },
    record?.is_agent_lead && { label: 'Agent Lead', bg: '#f0fdf4', color: '#166534', border: '#bbf7d0' },
    record?.is_follow_up && { label: 'Follow-up', bg: '#fff7ed', color: '#9a3412', border: '#fed7aa' },
    record?.is_voicemail && { label: 'Voicemail', bg: '#fff1f2', color: '#9f1239', border: '#fecdd3' },
    record?.is_ivr && { label: 'IVR', bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
    supervisor && record?.is_barge_in && { label: 'Barge In', bg: '#fee2e2', color: '#991b1b', border: '#fecaca' },
    supervisor && record?.is_whisper && { label: 'Whisper', bg: '#f5f3ff', color: '#5b21b6', border: '#ddd6fe' },
    supervisor && record?.is_monitor && { label: 'Monitor', bg: '#ecfdf5', color: '#065f46', border: '#a7f3d0' },
  ].filter(Boolean) as CallTypeBadge[];
}
